export default {
	API_URL: 'https://api-viva.infinitum-ti.com/api',
	OAPI_URL: 'https://api-viva.infinitum-ti.com/oapi',
	URL: 'https://api-viva.infinitum-ti.com/',
	// API_URL: 'http://localhost:2384/api',
	// OAPI_URL: 'http://localhost:2384/oapi',
	// URL: 'http://localhost:2384/'
}
